/** Digits only. */
export const phoneDigits = (value: string): string => value.replace(/\D/g, "");

/** Input mask `+D DDD DDD DD DD`, capped at the 11 digits a KZ number carries. */
export function formatPhone(value: string): string {
  // A masked value always carries its own "+"; only a raw, unprefixed paste
  // reaches here without one, which is the only case a bare 10-digit local
  // number (no country digit at all) needs the extra digit prepended below.
  const hasPrefix = value.trimStart().startsWith("+");
  let digits = phoneDigits(value).slice(0, 11);
  // The national dialing form starts with 8; normalize it to the +7 code.
  if (digits.startsWith("8")) digits = "7" + digits.slice(1);
  if (!hasPrefix && digits.length === 10 && digits.startsWith("7")) digits = "7" + digits;
  if (!digits) return "";
  let out = "+" + digits[0];
  if (digits.length > 1) out += " " + digits.slice(1, 4);
  if (digits.length > 4) out += " " + digits.slice(4, 7);
  if (digits.length > 7) out += " " + digits.slice(7, 9);
  if (digits.length > 9) out += " " + digits.slice(9, 11);
  return out;
}

export const isCompletePhone = (value: string): boolean => phoneDigits(value).length >= 11;

/** Started but unfinished — such a value would be dropped from the payload silently. */
export const isPartialPhone = (value: string): boolean => {
  const len = phoneDigits(value).length;
  return len > 1 && len < 11;
};

/** Wire format: no spaces. */
export const toPhonePayload = (value: string): string => value.replace(/\s/g, "");

/** E.164 (10-15 digits) — for numbers that need not be Kazakh, e.g. an invite recipient. */
export const isValidE164 = (value: string): boolean => {
  const len = phoneDigits(value).length;
  return len >= 10 && len <= 15;
};
